import { render } from "./CompProductsPreview.vue?vue&type=template&id=8608d080"
import script from "./CompProductsPreview.vue?vue&type=script&lang=js"
export * from "./CompProductsPreview.vue?vue&type=script&lang=js"

import "./CompProductsPreview.vue?vue&type=style&index=0&id=8608d080&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__